export default __webpack_public_path__ + "static/media/SpiffyShareLink.032ac737.png";